import Request from './request'

const Device_Test = {
  getDeviceSelfTestList (params, callback) {
    Request.post('device-test/selftest-list', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceFactoryList (params, callback) {
    Request.post('device-test/factory-list', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceTestSelfTestsResult(params, callback) {
    Request.post('device-test/selftest-result', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  statusDeviceTestSelfTest (id, params, callback) {
    Request.post('device-test/selftest-status/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  initDeviceTestSelfTest (id, params, callback) {
    Request.post('device-test/selftest-init/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default Device_Test
